export default "__VITE_ASSET__CZzkfu4F__"